import { render, staticRenderFns } from "./ViewEssayWriting.vue?vue&type=template&id=22bdde06&scoped=true"
import script from "./ViewEssayWriting.vue?vue&type=script&lang=js"
export * from "./ViewEssayWriting.vue?vue&type=script&lang=js"
import style0 from "./ViewEssayWriting.vue?vue&type=style&index=0&id=22bdde06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bdde06",
  null
  
)

export default component.exports